module.exports = __webpack_public_path__ + "static/Anioł z trąbką NAC-35b9d769f4dce6b4756f11b9415ce647.jpg";